<template>
  <div class="panel-admin-body dashboard">
    <div class="title pt-6 pb-6">
      <div class="d-flex dashboard">
        <span class="align-middle ml-1 button-center">{{ title }}<modal-link modal-id="How to Use" :image-size="'large'" :content-list="pageContent"></modal-link></span>
        <smart-center-link page="Competitive Dashboard" location="Single Pane Decision View" />
        <div class="small ml-auto">
          {{ new Date().toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "short", day: "numeric" }) }}
        </div>
        <div class="pl-3">
          <i v-show="this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
          <i v-show="!this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-12 align">
        <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
      </div>
    </div>
    <div class="new-competitive-dashboard">
      <dashboard-cards :entry-survey-code="surveyCode" :client-object="clientObject" :page-content-for-dashboard="pageContent" @client-time-period-change="onClientTimePeriodChange"/>
      <div class="row justify-content-center">       
        <div class="col-xl-6 col-md-8 pl-0">
          <saved-cards :view-type="'dashboard'" :enable-second-row-of-saved-charts="false" :display-dashboard-cards="false" :entry-survey-id="surveyId" :entry-survey-name="surveyName" :entry-client-object="clientObject" :page-content-for-dashboard="pageContent"/> 
          <div class="show-more float-right">
            <a href="#" @click="goToCards">Show more <i class="fa fa-chevron-down ml-1"></i></a>
          </div>
        </div>
        <div class="col-xl-3 col-md-4 pr-0">
          <saved-reports :view-type="'dashboard'" :entry-survey-id="surveyId" :entry-survey-name="surveyName" :entry-client-object="clientObject" @edit-report="initializeEditReport" @sort-reports="sortReports" :page-content-for-dashboard="pageContent"/>
          <div class="show-more float-right">
            <a href="#" @click="goToReports">Show more <i class="fa fa-chevron-down ml-1"></i></a>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
          <dashboard-value-players v-if="includeValuePlayers && currentTimePeriodId" 
          :view-type="'dashboard'" 
          :entry-survey-code="surveyCode" 
          :survey-id="surveyId" 
          :entry-client-object="clientObject" 
          :page-content-for-dashboard="pageContent"
          :client-time-period-id="currentTimePeriodId"
          :player-nodes="playerNodes"
          :key="currentTimePeriodId"
          />
      </div>
    </div>
  </div>
</template>
<script>
import DashboardCards from "../components/DashboardCards.vue";
import SavedCards from "../components/SavedCards.vue";
import ViewMixins from "../mixins/ViewMixins.vue";
import SavedCardMenu from "../views/menu/SavedCardMenu.vue";
import AdminService from "../services/admin.service";
import SurveyService from "../services/survey.service";
import ClientChartService  from "../services/client.chart.service";
import ReportService from "../services/report.service";
import DashboardMixins from "../mixins/DashboardMixins.vue";
import SavedReports from "../components/SavedReports.vue";
import DashboardValuePlayers from "../components/DashboardValuePlayers.vue";
import ClientTimePeriodService from "../services/client.time.period.service";
import ValuePlayerService from "../services/value.player.service";
import GlobalMixins from "../mixins/GlobalMixins.vue";

export default {
  name: "Dashboard",
  components: {
    SavedCardMenu,
    DashboardCards,
    SavedReports,
    SavedCards,
    DashboardValuePlayers
  },
  mixins: [ViewMixins, DashboardMixins,GlobalMixins],
  props: {
    baseUrl: {
      type: String,
      default: AdminService.getBaseUrl()
    }
  },
  data() {
    return {
      title: "Competitive Dashboard",
      includeValuePlayers: false,
      currentTimePeriodId: null,
      playerNodes: [],
    };
  },
  methods: {
    goToCards: function(){
      this.$router.replace({ path: "/analytics/report" });
    },
    goToReports: function(){
      this.$router.replace({ path: "/print-report" });
    },
    sortReports: function(sortBy) {
      if (sortBy == "title-ascending") {
        this.clientObject.clientReports.sort(ReportService.compareValues("title", "asc"));
      } else if (sortBy == "title-descending") {
        this.clientObject.clientReports.sort(ReportService.compareValues("title", "desc"));
      } else if (sortBy == "organization-ascending") {
        this.clientObject.clientReports.sort(ReportService.compareValues("clientName", "asc"));
      } else if (sortBy == "organization-descending") {
        this.clientObject.clientReports.sort(ReportService.compareValues("clientName", "asc"));
      } else if (sortBy == "date-added-newest") {
        this.clientObject.clientReports.sort(ReportService.compareValues("dateCreated", "desc"));
      } else if (sortBy == "date-added-oldest") {
        this.clientObject.clientReports.sort(ReportService.compareValues("dateCreated", "asc"));
      }      
    },
    initializeEditReport: function(){

    },
    async loadData() {
      this.survey = SurveyService.getSurvey();
      this.$root.processServerRequest();
      this.surveyId = SurveyService.getSurveyId();
      this.surveyName = SurveyService.getSurveyName();
      this.showValuePlayersChart();
    },
    async showValuePlayersChart() {
      await ValuePlayerService.getValuePlayerNodes(this.surveyId, this.getValuePlayerNodesCallback, this);
      await SurveyService.getSurveyFieldBySurveyId(this.surveyId, "include-value-players-on-dashboard", this.getSurveyFieldBySurveyIdCallback, this);
      await ClientTimePeriodService.getClientTimePeriodsBySurveyCode(this.surveyCode, this.getClientTimePeriodsBySurveyCodeCallback, this);
    },
    getValuePlayerNodesCallback(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.playerNodes = response.data.data
          .filter(node => node.label && node.label.trim() !== "")
          .map(node => ({
              id: String(node.sequenceNumber), // convert to string
              label: node.label.trim(),
              valuePlayerIconId: node.valuePlayerIcon?.valuePlayerIconId || "",
              icon: node.valuePlayerIcon?.imagePath || ""
          })
        );
      } else {
          AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    getClientTimePeriodsBySurveyCodeCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        if (typeof response.data.data.currentTimePeriod != "undefined") {
          this.currentTimePeriodId = String(response.data.data.currentTimePeriod);
        }
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    getSurveyFieldBySurveyIdCallback(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        const res = response.data.data;
        this.includeValuePlayers = (res === true || res === "true" || res === "Y") && this.playerNodes && this.playerNodes.length > 0;
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    getPageContentCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContent = [...this.pageContent, ...response.data.data];
      }
    },
    onClientTimePeriodChange(value) {
      this.currentTimePeriodId = value;
    }
  },
  watch: {
    surveyCode: function() {
      this.loadData();
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$root.setShowMenuIcon(true);  
    this.getPageContent("Dashboard");
  },
  umnounted() {},
  computed: {
    clientChartsBySurvey: function() {
      let originalClientCharts = this.clientObject.clientCharts;
      let surveyIdToCompare = SurveyService.getSurveyId();
      return ClientChartService.getClientChartsBySurvey(originalClientCharts, surveyIdToCompare, false);
    },    
  }
};
</script>
